import { Alert, AlertDescription, AlertTitle } from '@/components/ui/Alert';
import { Icon } from '@/components/wm';
import clsx from 'clsx';
import { AnimatePresence, motion } from 'framer-motion';
import React, { useEffect } from 'react';

const AlertBox = ({
    active,
    animation = true,
    animationProps = {},
    deactivateAlert,
    children,
    duration = 0, // Duration in milliseconds, 0 means permanent
    icon = null,
    title = null,
    variant = '',
    className = ''
}) => {
    useEffect(() => {
        let timer;
        if (active && duration > 0) {
            timer = setTimeout(() => {
                deactivateAlert();
            }, duration);
        }
        return () => clearTimeout(timer);
    }, [active, duration, deactivateAlert]);

    const defaultAnimationProps = {
        animate: { opacity: 1 },
        exit: { opacity: 0 },
        initial: { opacity: 0 },
        transition: { duration: 1 }
    };

    const mergedAnimationProps = animation ? { ...defaultAnimationProps, ...animationProps } : {};

    return (
        <AnimatePresence>
            {active && (
                <motion.div {...mergedAnimationProps}>
                    <Alert className={clsx('tw-flex tw-flex-col tw-p-4 tw-mt-4', className)} variant={variant}>
                        <div className="tw-flex tw-items-center tw-mb-2" style={{ color: 'inherit' }}>
                            {icon && (
                                <Icon color={variant} icon={variant}/>
                            )}
                            {title && (
                                <AlertTitle className="tw-text-base tw-ml-2">{title}</AlertTitle>
                            )}
                        </div>
                        <AlertDescription className="tw-flex-grow">{children}</AlertDescription>
                    </Alert>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export { AlertBox };
